import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { configureStore } from "./redux/store";
import { Worker } from "@react-pdf-viewer/core";
import { SW_INIT, SW_UPDATE } from "./redux/app/type";

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
      <App />
    </Worker>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.register({
  onSuccess: () => store.dispatch({ type: SW_INIT }),
  onUpdate: (registration) =>
    store.dispatch({ type: SW_UPDATE, payload: registration }),
});
